module.exports = __webpack_public_path__ + "static/media/dm.40bb9498.svg";